import { render, staticRenderFns } from "./ModalEmployeeProfile.vue?vue&type=template&id=157b5266&"
import script from "./ModalEmployeeProfile.vue?vue&type=script&lang=js&"
export * from "./ModalEmployeeProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports